import { LosseLink, LossePlaatjie } from '@ubo/losse-sjedel'
import { Fragment } from 'react'
import Animated from '~/components/elements/Animated'
import type { Page_Flexcontent_Flex_Content } from '~/graphql/types'

export default function ContentInternalLinks({ fields }: { fields: Page_Flexcontent_Flex_Content }) {
  return (
    <section data-component="ContentInternalLinks" className="section">
      <div className="container">
        <Animated delay={100}>
          <h2 className="title--medium pb-4">
            {fields.title.split('|')?.map((t, i) => (
              <Fragment key={i}>
                <span>{t}</span>
                <br />
              </Fragment>
            ))}
          </h2>
        </Animated>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mt-4 sm:mt-10">
          {fields.items?.map((item, index) => (
            <Animated delay={300} key={index}>
              <div key={index}>
                <LosseLink
                  target={item.link.target || '_self'}
                  to={item.link.url}
                  style={{
                    animationDelay: `${index * 100 + 300}ms`,
                    boxShadow: '0px 0px 3.903px 0px rgba(0, 0, 0, 0.25)'
                  }}
                  className="flex group h-full px-8 lg:px-12 py-6 lg:py-8 gap-x-8 gap-y-5 lg:gap-x-14 gap-3"
                >
                  <div>
                    <LossePlaatjie
                      className="w-[70px] h-[70px] lg:w-[100px] lg:min-w-[100px] lg:min-h-[100px] lg:h-[100px] object-contain"
                      src={item.image}
                    />
                  </div>
                  <div className="">
                    <div className="bg-site-accent w-[100px] lg:w-[120px] text-center rounded-full px-2 lg:px-4 py-1 lg:py-2 text-white text-xs">
                      {item.subtitle}
                    </div>
                    <div className="text-site-base group-hover:underline mt-3 lg:mt-5 font-bold lg:text-2xl text-xl">{item.title}</div>
                  </div>
                </LosseLink>
              </div>
            </Animated>
          ))}
        </div>
      </div>
    </section>
  )
}
